import React from 'react';

const Loading = () => {
  return (
    <div className="loader-container">
      <img
        className="loader-image"
        alt="loading"
        src={process.env.PUBLIC_URL + '/img/loading.gif'}
      />
    </div>
  );
};

export default Loading;
